import { ZYNDAY_DEMO_PROFILES } from '../../shared/src/experimental/zynday-demo-profile';

export const environment = {
  production: true,
  envName: 'staging',
  apiUrl: 'https://api-staging.zynday.com/v2',
  wsUrl: 'wss://api-staging.zynday.com/v2',
  posthogKey: 'phc_7bwYyvgzvoBusmOgi2ATAahCekI3jGN9HDE7sLgU9rB',
  posthogHost: 'https://eu.i.posthog.com',

  // Feature flags
  showTrialBanner: true,
  enablePurchases: true,
  bookingWizardUrl: 'https://stage-book.zynday.com',
  zyndayDemoProfile: ZYNDAY_DEMO_PROFILES.stage,
  turnstileSiteKey: '0x4AAAAAACgxHpH6JEvJYhZ2',
  // Google sign-in — expected GIS client ID (placeholder until issue 0001 lands the real per-env IDs)
  googleClientId:
    '427006462167-sj9ihuc4onjpfoilehs3ij95oo1cie85.apps.googleusercontent.com',
};
